import { dealerService } from "../services";

import { dealerConstants, userConstants } from "../constants";
import { alertActions } from ".";
import { history } from "../helpers";

export const dealerMasterActions = {
  getAll,
  getAlltoApprove,
  getStateDDL,
  getFirmDDL,
  getBCityDDL,
  getDistrictDDL,
  createDealer,
  createDistributor,
  updateDistributor,
  updateDealer,
  updateContractor,
  inActiveRow,
  updatePaymentStatus,
  onHideShow,
  loadingData,
  onHideShowIsActive,
  getTransportationModeDDL,
  exportData,
  GETPAYMENTDDL,
  getDCityDDL,
  getDStateDDL,
  GETDOCUMENTTYPEDDL,
  GetSalesPersonDDL,
  GetDistributorByUserId,
};


function GetDistributorByUserId(userId) {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_DISTRIBUTOR_BY_USER_REQUEST" });

      const result = await dealerService.GetDistributorByUserId(userId);

      console.log("GetDistributorByUserId result:", result);

      if (
        result &&
        (result.ResponseCode === 200 || result.ResponseCode === "200")
      ) {
        dispatch({
          type: "GET_DISTRIBUTOR_BY_USER_SUCCESS",
          payload: result.ResponseData,
        });
      } else {
        dispatch({
          type: "GET_DISTRIBUTOR_BY_USER_FAILURE",
          payload: result,
        });

        dispatch(
          alertActions.warning(result.ResponseMessage || "No data found")
        );
      }

      return result;
    } catch (error) {
      console.error("GetDistributorByUserId error:", error);

      dispatch({
        type: "GET_DISTRIBUTOR_BY_USER_FAILURE",
        payload: error.message,
      });

      dispatch(alertActions.error(error.message));

      throw error;
    }
  };
};


function updateDistributor(data, tblResponse) {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_DISTRIBUTOR_REQUEST" });

      const result = await dealerService.updateDistributor(data);
      console.log("updateDistributor result:", result);
      debugger;

      if (result.ResponseCode === 200) {
        dispatch({ type: "UPDATE_DISTRIBUTOR_SUCCESS", payload: result });
        // Refresh table after update
        dispatch(getAll(tblResponse));
        dispatch(onHideShow(false));

        // ✅ Success Toastr
        dispatch(alertActions.success(result.ResponseMessage));
      } else {
        dispatch(alertActions.warning(result.ResponseMessage));
      dispatch({ type: "UPDATE_DISTRIBUTOR_FAILURE", payload: result });
    }
 
    return result;
  } catch (error) {
    console.error("updateDistributor error:", error);
    dispatch(alertActions.error(error.message));
    dispatch({ type: "UPDATE_DISTRIBUTOR_FAILURE", payload: error.message });
    throw error;
  }
}};


function getAll(obj) {
  return (dispatch) => {
    dispatch(request());
    dealerService.fetchDealerData(obj).then(
      (response) => {
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(loadingData(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
   

  function request() {
    return { type: dealerConstants.GETALL_REQUEST };
  }
  function success(datas) {
    return { type: dealerConstants.GETALL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerConstants.GETALL_FAILURE, error };
  }
}
function getAlltoApprove(obj) {
  return (dispatch) => {
    dispatch(request());
    dealerService.fetchDealerDatatoApprove(obj).then(
      (response) => {
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(loadingData(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dealerConstants.GETALL_REQUEST };
  }
  function success(datas) {
    return { type: dealerConstants.GETALL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerConstants.GETALL_FAILURE, error };
  }
}

function getStateDDL(data) {
  console.log("getStateDDL");
  return (dispatch) => {
    dispatch(request());

    dealerService.fetchStateDLL(data).then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dealerConstants.GETSTATEDDL_REQUEST };
  }
  function success(datas) {
    return { type: dealerConstants.GETSTATEDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerConstants.GETSTATEDDL_FAILURE, error };
  }
}

function getDStateDDL(data) {
  console.log("getDStateDDL");
  return (dispatch) => {
    dispatch(request());

    dealerService.fetchDStateDLL(data).then(
      (response) => {
        console.log("res", response.ResponseData);
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dealerConstants.GETDSTATEDDL_REQUEST };
  }
  function success(datas) {
    return { type: dealerConstants.GETDSTATEDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerConstants.GETDSTATEDDL_FAILURE, error };
  }
}

function exportData(obj) {
  return (dispatch) => {
    dispatch(request());
    dealerService.fetchDealerDataforExport(obj).then(
      (response) => {
        dispatch(loadingData(false));
        var data = response.ResponseData;
        if (data != null) {
          data.forEach(function (v) {
            delete v.TotalRows;
            delete v.UserId;
            delete v.FirstName;
            delete v.LastName;
            delete v.RoleId;
            delete v.UserType;
            delete v.IsActive;
            delete v.IsResetPassword;
            delete v.Password;
            delete v.Token;
            delete v.RefreshToken;
            delete v.Salt;
            delete v.CreatedBy;
            delete v.UpdatedBy;
            delete v.DealerId;
            delete v.CreatedDate;
            delete v.CountryId;
            delete v.UserName;
            delete v.City;
            delete v.GstCertificate;
            delete v.Country;
            delete v.State;
            delete v.isApproved;
            delete v.isDeleted;
            delete v.isDealer;
            delete v.isMechanic;
            delete v.UserCode;
            delete v.District;
            delete v.AadharDoc1;
            delete v.AadharDoc2;
            delete v.PanNo;
            delete v.PanNoDoc;
            delete v.UpdatedDate;
            delete v.WorkshopImg;
            delete v.CompanyName;
          });
        }
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: dealerConstants.GETEXPORT_REQUEST };
  }
  function success(datas) {
    return { type: dealerConstants.GETEXPORT_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerConstants.GETEXPORT_FAILURE, error };
  }
}

function getFirmDDL() {
  return (dispatch) => {
    dispatch(request());

    dealerService.fetchFirmDLL().then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dealerConstants.GETFIRMDDL_REQUEST };
  }
  function success(datas) {
    return { type: dealerConstants.GETFIRMDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerConstants.GETFIRMDDL_FAILURE, error };
  }
}

function GETPAYMENTDDL() {
  return (dispatch) => {
    dispatch(request());

    dealerService.GETPAYMENTDDL().then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dealerConstants.GETPAYMENTDDL_REQUEST };
  }
  function success(datas) {
    return { type: dealerConstants.GETPAYMENTDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerConstants.GETPAYMENTDDL_FAILURE, error };
  }
}

function GETDOCUMENTTYPEDDL() {
  return (dispatch) => {
    dispatch(request());

    dealerService.GETDOCUMENTTYPEDDL().then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dealerConstants.GETDOCUMENTTYPEDDL_REQUEST };
  }
  function success(datas) {
    return { type: dealerConstants.GETDOCUMENTTYPEDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerConstants.GETDOCUMENTTYPEDDL_FAILURE, error };
  }
}

function GetSalesPersonDDL() {
  return (dispatch) => {
    dispatch(request());

    dealerService.GetSalesPersonDDL().then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dealerConstants.GETSALESPERSONDDL_REQUEST };
  }
  function success(datas) {
    return { type: dealerConstants.GETSALESPERSONDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerConstants.GETSALESPERSONDDL_FAILURE, error };
  }
}

function getTransportationModeDDL() {
  return (dispatch) => {
    dispatch(request());

    dealerService.fetchTransportationModeDDL().then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dealerConstants.GET_TRANSPORTATION_REQUEST };
  }
  function success(datas) {
    return { type: dealerConstants.GET_TRANSPORTATION_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerConstants.GET_TRANSPORTATION_FAILURE, error };
  }
}

// function getBCityDDL(data) {
//   ;
//   return (dispatch) => {
//     dispatch(request());

//     dealerService.fetchCityDLL(data).then(
//       (response) => {
//         dispatch(success(response.ResponseData));
//       },
//       (error) => {
//         dispatch(failure(error.toString()));
//         dispatch(alertActions.error(error.toString()));
//       }
//     );
//   };
//   function request() {
//     return { type: dealerConstants.GETBCITYDDL_REQUEST };
//   }
//   function success(datas) {
//      ;
//     return { type: dealerConstants.GETBCITYDDL_SUCCESS, datas };
//   }
//   function failure(error) {
//     return { type: dealerConstants.GETBCITYDDL_FAILURE, error };
//   }
// }

function getBCityDDL(data) {
  return (dispatch) => {
    dispatch(request());

    return dealerService.fetchCityDLL(data).then(
      (response) => {
        dispatch(success(response.ResponseData));
        return response.ResponseData; // 🔁 Return the response for chaining
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
        throw error; // ❗️Optional: re-throw to handle in .catch
      }
    );
  };

  function request() {
    return { type: dealerConstants.GETBCITYDDL_REQUEST };
  }
  function success(datas) {
    return { type: dealerConstants.GETBCITYDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerConstants.GETBCITYDDL_FAILURE, error };
  }
}

function getDCityDDL(data) {
  return (dispatch) => {
    dispatch(request());

    dealerService.fetchDCityDLL(data).then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: dealerConstants.GETDCITYDDL_REQUEST };
  }
  function success(datas) {
    return { type: dealerConstants.GETDCITYDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerConstants.GETDCITYDDL_FAILURE, error };
  }
}

function getDCityDDL2() {
  return (dispatch) => {
    dispatch(request());

    dealerService.fetchDCityDLL2().then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request() {
    return { type: dealerConstants.GETDCITYDDL_REQUEST };
  }
  function success(datas) {
    return { type: dealerConstants.GETDCITYDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerConstants.GETDCITYDDL_FAILURE, error };
  }
}

function getDistrictDDL(data) {
  return (dispatch) => {
    // dispatch(request());

    dealerService.fetchDistrictDLL(data).then(
      (response) => {
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dealerConstants.GETSDISTRICTDDL_REQUEST };
  }
  function success(datas) {
    return { type: dealerConstants.GETSDISTRICTDDL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: dealerConstants.GETSDISTRICTDDL_FAILURE, error };
  }
}

function createDealer(data, obj) {
  return (dispatch) => {
    dispatch(request(data));

    dealerService.createDealer(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(response.ResponseData));
            dispatch(onHideShow(false));
            dispatch(getAlltoApprove(obj));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: userConstants.CREATE_REQUEST, data };
  }
  function success(data) {
    return { type: userConstants.CREATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.CREATE_FAILURE, error };
  }
}

function createDistributor(data, obj) {
  return (dispatch) => {
    dispatch(request(data));

    dealerService.createDistributor(data).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === 200) {
            dispatch(success(response.ResponseData));
            dispatch(onHideShow(false));
            // ✅ Only call getAlltoApprove if obj is provided
            if (obj) {
              dispatch(getAlltoApprove(obj));
            }
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === 400) {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: userConstants.CREATE_REQUEST, data };
  }
  function success(data) {
    return { type: userConstants.CREATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: userConstants.CREATE_FAILURE, error };
  }
}

function updateDealer(data, obj) {
  return (dispatch) => {
    dispatch(request(data));

    dealerService.updateDealer(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            // dispatch(getAlltoApprove(obj));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealerConstants.UPDATE_REQUEST, data };
  }
  function success(data) {
    return { type: dealerConstants.UPDATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealerConstants.UPDATE_FAILURE, error };
  }
}

function updateContractor(data, obj) {
  return (dispatch) => {
    dispatch(request(data));

    dealerService.updateContractor(data).then(
      (response) => {
        //history.push('/');
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(getAll(obj));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: dealerConstants.UPDATE_REQUEST, data };
  }
  function success(data) {
    return { type: dealerConstants.UPDATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealerConstants.UPDATE_FAILURE, error };
  }
}

function inActiveRow(user, isActive) {
  var data = {
    UserId: user,
    IsActive: isActive,
  };
  return (dispatch) => {
    dispatch(request());

    dealerService.inActiveRow(user, isActive).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShowIsActive(false));
            dispatch(alertActions.success(response.ResponseMessage));
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
          }
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dealerConstants.ISACTIVE_REQUEST };
  }
  function success(data) {
    return { type: dealerConstants.ISACTIVE_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealerConstants.ISACTIVE_FAILURE, error };
  }
}

export function updatePaymentStatus(userId, isPayment) {
  const data = {
    UserId: userId,
    IsPayment: isPayment,
  };

  return (dispatch) => {
    dispatch(request());

    return dealerService.updatePaymentStatus(userId, isPayment).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(alertActions.success(response.ResponseMessage));
            return Promise.resolve(response); // ✅ Make it thenable
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
            return Promise.reject(response); // ❌ Trigger .catch() in component
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
            return Promise.reject(response);
          }
        } else {
          return Promise.reject("Unexpected response");
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
        return Promise.reject(error); // ✅ Ensure .catch() in component works
      }
    );
  };

  function request() {
    return { type: dealerConstants.UPDATE_PAYMENT_REQUEST };
  }
  function success(data) {
    return { type: dealerConstants.UPDATE_PAYMENT_SUCCESS, data };
  }
  function failure(error) {
    return { type: dealerConstants.UPDATE_PAYMENT_FAILURE, error };
  }
}

function onHideShow(isbool) {
  return {
    type: dealerConstants.DIALOG_REQUEST,
    isbool,
  };
}

function loadingData(isbool) {
  return {
    type: dealerConstants.LOADING_REQUEST,
    isbool,
  };
}

function onHideShowIsActive(isbool) {
  return {
    type: dealerConstants.DIALOG_ISACTIVE_REQUEST,
    isbool,
  };
}
